import { useContext } from "react";
import { AppContext } from "../App";
import { NavigationButtons } from "./NavigationButtons";

export const Footer = () => {
  const { isSubmissionCreated } = useContext(AppContext);
  if (isSubmissionCreated) return null;

  return <NavigationButtons />;
};
